import { Component } from 'react'
import PropTypes from 'prop-types'

import View from './component'

export default View
